import axiosInstance from '../axiosInterceptor/axiosInstance'

const reorderGroups = async ({ orgId, stageId, orderedIds }) => {
  const url = `v1/orgs/${orgId}/groups/reorder?stageId=${stageId}`
  const response = await axiosInstance.patch(url, JSON.stringify({ orderedIds }))
  return response?.data
}

export default reorderGroups
